var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "word-search-grid-wrapper" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-6 d-flex align-items-center" },
        [
          _c(_setup.CInput, {
            staticClass: "flex-fill",
            attrs: {
              type: "number",
              label: "Grid Cols",
              disabled: _setup.disabled,
            },
            on: {
              blur: function ($event) {
                return _setup.updateGridCols(_setup.model.gridCols)
              },
            },
            model: {
              value: _setup.model.gridCols,
              callback: function ($$v) {
                _vm.$set(_setup.model, "gridCols", $$v)
              },
              expression: "model.gridCols",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-6 d-flex align-items-center" },
        [
          _c(_setup.CInput, {
            staticClass: "flex-fill",
            attrs: {
              type: "number",
              label: "Grid Rows",
              disabled: _setup.disabled,
            },
            on: {
              blur: function ($event) {
                return _setup.updateGridRows(_setup.model.gridRows)
              },
            },
            model: {
              value: _setup.model.gridRows,
              callback: function ($$v) {
                _vm.$set(_setup.model, "gridRows", $$v)
              },
              expression: "model.gridRows",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }